/*  MUI  */
import { PersonOutline } from '@mui/icons-material';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ClientIcon = () => {
    const { t } = useTranslation();

    return (
        <DarkTooltip arrow title={t('Common.client_note')}>
            <PersonOutline
                sx={{ color: 'notes.icon.client' }}
                fontSize="large"
            />
        </DarkTooltip>
    );
};
